import { Box, IconButton, Stack } from '@mui/material';
import { PropsWithChildren } from 'react';
import { DrawerContentHeader } from './DrawerContentHeader';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

export default function DrawerContentArea({
  title,
  titleId,
  children,
  onClose,
}: PropsWithChildren<{
  title: string;
  titleId?: string;
  onClose?: () => void;
}>) {
  const { t } = useTranslation();

  return (
    <Box sx={{ paddingX: 0.5 }}>
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        sx={{ paddingTop: 1.5, paddingLeft: 1.5 }}
      >
        <DrawerContentHeader id={titleId}>{title}</DrawerContentHeader>
        {onClose && (
          <IconButton
            onClick={onClose}
            aria-label={`${t('readingView.menu.close')}`}
          >
            <CloseIcon />
          </IconButton>
        )}
      </Stack>
      <Stack direction='column'>{children}</Stack>
    </Box>
  );
}
